import r from "./component-library105.js";
/* empty css                     */
import i from "./component-library98.js";
var s = function() {
  var e = this, n = e._self._c, t = e._self._setupProxy;
  return e.variants ? n("span", { staticClass: "variant-selector-color", attrs: { role: t.hasSelection ? "radiogroup" : void 0, "aria-label": t.hasSelection ? "Farbe auswählen" : void 0 } }, [e._l(e.variants, function(a, o) {
    return [n(t.Tooltip, { key: o + a.name, attrs: { text: a.name, "open-on-hover": "", "inner-aria-hidden": "", role: t.hasSelection ? "radio" : void 0, position: "bottom", "aria-checked": t.isChecked(o), tabindex: e.isAccessible ? void 0 : -1, "aria-label": t.hasSelection ? `Farbe: ${a.name}` : void 0, "open-on-click": !1, "mobile-first-tap-tooltip": "", button: {
      tag: t.hasSelection ? "button" : "span",
      type: t.hasSelection ? "button" : "span",
      iconOnly: !0,
      outlinePrimary: o === e.value,
      outline: o !== e.value,
      checked: o === e.value
    } }, on: { click: function(u) {
      e.$emit("input", o), e.$emit("select-variant", { variant: a });
    } } }, [n("span", { staticClass: "variant-selector-color__inner", style: t.style(a.color) })])];
  })], 2) : e._e();
}, l = [], c = /* @__PURE__ */ i(
  r,
  s,
  l,
  !1,
  null,
  "fb0a21c8"
);
const f = c.exports;
export {
  f as default
};
